import { render, staticRenderFns } from "./SelectPaymentNig.vue?vue&type=template&id=39367ca8&scoped=true&"
import script from "./SelectPaymentNig.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentNig.vue?vue&type=script&lang=js&"
import style0 from "./SelectPaymentNig.vue?vue&type=style&index=0&id=39367ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39367ca8",
  null
  
)

export default component.exports